export const filterCallsByIncomingAndOutgoing = (calls, incoming, outgoing) => {
  switch (true) {
    case !incoming && outgoing:
      return calls.filter((call) => !call?.incoming);
    case incoming && !outgoing:
      return calls.filter((call) => call?.incoming);
    default:
      return calls;
  }
};

export const filterCallsByDepartment = (calls, department) => {
  const filtered_calls = calls.filter((call) => call.department === department);
  return filtered_calls;
};

// Call duration (call_duration_seconds) as m:ss, or h:mm:ss from one hour.
// "–" when unknown: older calls were stored without a duration.
export const formatCallDuration = (seconds) => {
  const total = Number(seconds);
  if (seconds === null || seconds === undefined || seconds === "") return "–";
  if (!Number.isFinite(total) || total < 0) return "–";

  const rounded = Math.round(total);
  const hours = Math.floor(rounded / 3600);
  const minutes = Math.floor((rounded % 3600) / 60);
  const secs = String(rounded % 60).padStart(2, "0");

  if (hours > 0) return `${hours}:${String(minutes).padStart(2, "0")}:${secs}`;
  return `${minutes}:${secs}`;
};
